<template>
  <div>
    <div class="card-body">
      <div class="tab-content" id="nav-tabContent">
        <div class="p-10">
          Tổng số ĐVCNT:
          <strong class="text-primary">{{
            (pagination.total || 0).toLocaleString('vi-VN')
          }}</strong>
          <b-table
            :busy.sync="loading"
            sticky-header
            hover
            responsive
            :items="listTpv"
            :fields="fieldsTable"
            :fixed="true"
            :bordered="true"
          >
            <template #table-busy>
              <div class="my-2 text-center">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(index)="{ index }">
              {{ getIndex(index) }}
            </template>
            <template #cell(merchantName)="data">
              <p>{{ data.item.merchantName ?? '' }}</p>
              <p>{{ data.item.merchantEmail ?? '' }}</p>
              <p>{{ data.item.mcc ? joinArrayData(data.item.mcc, dataConfigMcc) : '' }}</p>
              <p>
                <span :class="`badge ${getStatusClass(data.item.status)}`" v-if="data.item.status">
                  {{ joinArrayData(data.item.status, listMcStatus) }}
                </span>
              </p>
            </template>
            <template #cell(merchantType)="data">
              <p>{{ data.item.level ? joinArrayData(data.item.level, optionMerchantType) : '' }}</p>
            </template>
            <template #cell(sales)="data">
              <p>
                {{ data.item.userCare && data.item.userCare.name ? data.item.userCare.name : '' }}
              </p>
              <p>
                {{ data.item.userCare && data.item.userCare.email ? data.item.userCare.email : '' }}
              </p>
            </template>
            <template #cell(tpv)="data">
              <div
                v-for="tpv in displayTpvTypeMcList"
                v-if="search.showTpvType && search.showTpvType === 'MC_GROUP'"
              >
                <p v-if="data.item.tpvTypeMcList.hasOwnProperty(tpv.id) && tpv.id === 'TOTAL'">
                  <span class="text-muted">{{ tpv.text }}:</span
                  ><span class="text-primary">{{
                    data.item.tpvTypeMcList[tpv.id].totalTpv | transformMoney
                  }}</span>
                </p>
                <p v-else-if="data.item.tpvTypeMcList.hasOwnProperty(tpv.id)" :key="tpv.id">
                  <span class="text-muted">{{ tpv.text }}:</span
                  >{{ data.item.tpvTypeMcList[tpv.id].totalTpv | transformMoney }}
                </p>
                <p v-else>
                  <span class="text-muted">{{ tpv.text }}:</span>0
                </p>
              </div>
              <div
                v-for="tpv in displayTpvTypeTransactionList"
                v-if="search.showTpvType && search.showTpvType === 'TRANSACTION_TYPE'"
              >
                <p
                  v-if="
                    data.item.tpvTypeTransactionList.hasOwnProperty(tpv.id) && tpv.id === 'TOTAL'
                  "
                >
                  <span class="text-muted">{{ tpv.text }}:</span
                  ><span class="text-primary">{{
                    data.item.tpvTypeTransactionList[tpv.id].totalTpv | transformMoney
                  }}</span>
                </p>
                <p
                  v-else-if="data.item.tpvTypeTransactionList.hasOwnProperty(tpv.id)"
                  :key="tpv.id"
                >
                  <span class="text-muted">{{ tpv.text }}:</span
                  >{{ data.item.tpvTypeTransactionList[tpv.id].totalTpv | transformMoney }}
                </p>
                <p v-else>
                  <span class="text-muted">{{ tpv.text }}:</span>0
                </p>
              </div>
            </template>
            <template #cell(tpvKpi)="data">
              <div
                v-for="tpvKpi in displayTpvTypeMcList"
                v-if="search.showTpvType && search.showTpvType === 'MC_GROUP'"
              >
                <p
                  v-if="data.item.tpvTypeMcList.hasOwnProperty(tpvKpi.id) && tpvKpi.id === 'TOTAL'"
                >
                  <span class="text-muted">{{ tpvKpi.text }}:</span
                  ><span class="text-success">{{
                    data.item.tpvTypeMcList[tpvKpi.id].totalTpvKpi | transformMoney
                  }}</span>
                </p>
                <p v-else-if="data.item.tpvTypeMcList.hasOwnProperty(tpvKpi.id)" :key="tpvKpi.id">
                  <span class="text-muted">{{ tpvKpi.text }}:</span
                  >{{ data.item.tpvTypeMcList[tpvKpi.id].totalTpvKpi | transformMoney }}
                </p>
                <p v-else>
                  <span class="text-muted">{{ tpvKpi.text }}:</span>0
                </p>
              </div>
              <div
                v-for="tpvKpi in displayTpvTypeTransactionList"
                v-if="search.showTpvType && search.showTpvType === 'TRANSACTION_TYPE'"
              >
                <p
                  v-if="
                    data.item.tpvTypeTransactionList.hasOwnProperty(tpvKpi.id) &&
                    tpvKpi.id === 'TOTAL'
                  "
                >
                  <span class="text-muted">{{ tpvKpi.text }}:</span
                  ><span class="text-success">{{
                    data.item.tpvTypeTransactionList[tpvKpi.id].totalTpvKpi | transformMoney
                  }}</span>
                </p>
                <p v-else-if="data.item.tpvTypeTransactionList.hasOwnProperty(tpvKpi.id)">
                  <span class="text-muted">{{ tpvKpi.text }}:</span
                  >{{ data.item.tpvTypeTransactionList[tpvKpi.id].totalTpvKpi | transformMoney }}
                </p>
                <p v-else :key="tpvKpi.id">
                  <span class="text-muted">{{ tpvKpi.text }}:</span>0
                </p>
              </div>
            </template>
            <template #cell(action)="{ item }">
              <div class="text-left m-b-5">
                <b-link @click="toDetailV1(item)" style="color: #0056f6" size="sm">
                  <img
                    src="@/assets/img/circle-three-dots.svg"
                    alt="Circle with Three Dots"
                    style="width: 15px; height: 15px"
                  />
                  Chi tiết
                </b-link>
              </div>
              <div
                class="text-left m-b-5"
                v-if="search.showTpvType && search.showTpvType !== 'MC_GROUP'"
              >
                <b-link @click="toDetailV2(item)" style="color: #0056f6" size="sm">
                  <img
                    src="@/assets/img/circle-three-dots.svg"
                    alt="Circle with Three Dots"
                    style="width: 15px; height: 15px"
                  />
                  Chi tiết TPV của MC
                </b-link>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        @change="onChangePage"
        :total-rows="pagination.total"
        :per-page="search.limit"
        class="mr-2 fl-right"
      ></b-pagination>
    </div>
    <detailV2 ref="popupDetailV2Ref" :dataConfigMcc="dataConfigMcc" />
  </div>
</template>
<script>
  import { filterMcTpvTxDetail } from '@/services/customer-support/tpv'
  import detailV2 from '../detailV2.vue'

  export default {
    props: {
      dataConfigMcc: {
        type: Array,
        default: () => [],
      },
      listMcStatus: {
        type: Array,
        default: () => [],
      },
      fieldsTable: {
        type: Array,
        default: () => [],
      },
    },
    components: { detailV2 },
    data() {
      return {
        loading: false,
        // filterTable: this.fieldsTable,
        listTpv: [],
        search: {
          page: 1,
          limit: 20,
        },
        pagination: {
          total: 0,
        },
        optionMerchantType: [
          { id: 'MC_KEY', text: 'Merchant key' },
          { id: 'MC_NORMAL', text: 'Merchant thường' },
        ],
        displayTpvTypeMcList: [
          { id: 'TOTAL', text: 'Tổng' },
          { id: 'NEW_MC', text: 'MC mới' },
          { id: 'OLD_MC_NEW_BRANCH', text: 'MC cũ CN mới' },
          { id: 'OLD_MC_REACTIVATED', text: 'MC cũ kích hoạt lại' },
          { id: 'OTHER', text: 'MC không tính KPI' },
        ],
        displayTpvTypeTransactionList: [
          { id: 'TOTAL', text: 'Tổng' },
          { id: 'MANUAL_PAYMENT', text: 'Thanh toán có hiện diện' },
          { id: 'ONLINE_PAYMENT', text: 'Thanh toán không hiện diện' },
          { id: 'INSTALLMENT', text: 'Thanh toán trả góp' },
          { id: 'BNPL', text: 'BNPL' },
          { id: 'MOTO', text: 'MOTO' },
          { id: 'LENDING_NEXTLEND', text: 'Nextlend' },
          { id: 'OTHER', text: 'Other' },
        ],
      }
    },
    computed: {
      joinArrayData() {
        return (item, options) => {
          const mapData = options.find(e => e.id === item)
          return mapData ? mapData.text : ''
        }
      },
      getStatusClass() {
        return status => {
          const objStatus = this.listMcStatus.find(s => s.id === status)
          return objStatus ? objStatus.bgColor : 'badge-primary'
        }
      },
      mapArrayKey() {
        return array => {
          if (!array || array.length === 0) return {}
          const mapData = array.reduce((acc, current) => {
            if (!acc[current.key]) acc[current.key] = current

            return acc
          }, {})
          return mapData
        }
      },
    },
    methods: {
      async fetchData() {
        try {
          this.loading = true
          const res = await filterMcTpvTxDetail(this.search)
          if (res.code === 1000 && res.data) {
            this.pagination.total = res.data.count ?? 0
            this.listTpv = res.data.tpvMcSummary ?? []
            this.listTpv.map(item => {
              if (item.tpvTypeMcList && item.tpvTypeMcList.length > 0) {
                const tpvTypeMcList = item.tpvTypeMcList.reduce((acc, current) => {
                  if (!acc[current.key]) acc[current.key] = current
                  if (!acc.TOTAL) acc.TOTAL = { key: 'TOTAL', totalTpv: 0, totalTpvKpi: 0 }

                  acc.TOTAL.totalTpv += current.totalTpv
                  acc.TOTAL.totalTpvKpi += current.totalTpvKpi
                  return acc
                }, [])
                item.tpvTypeMcList = tpvTypeMcList
              }
              if (item.tpvTypeTransactionList && item.tpvTypeTransactionList.length > 0) {
                const tpvTypeTransactionList = item.tpvTypeTransactionList.reduce(
                  (acc, current) => {
                    if (!acc[current.key]) acc[current.key] = current
                    if (!acc.TOTAL) acc.TOTAL = { key: 'TOTAL', totalTpv: 0, totalTpvKpi: 0 }

                    acc.TOTAL.totalTpv += current.totalTpv
                    acc.TOTAL.totalTpvKpi += current.totalTpvKpi
                    return acc
                  },
                  []
                )
                item.tpvTypeTransactionList = tpvTypeTransactionList
              }
            })
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.loading = false
        }
      },
      loadData(filter) {
        this.search = {
          ...filter,
          page: 1,
          limit: 20,
        }
        this.fetchData()
      },
      onChangePage(page) {
        this.search.page = page
        this.fetchData()
      },
      toDetailV2(item) {
        this.$refs.popupDetailV2Ref.show(item, this.search)
      },
      toDetailV1(item) {
        this.$router.push({
          path: `/customer-support/tpv-ma/${item.merchantMposId}`,
          // name: 'TPV MA Detail',
          // params: { dataItem: item }
        })
      },
    },
  }
</script>
<style scoped></style>
